/**
 * Contiguous runs of `true` in the per-day override flags (one entry per visible column).
 *
 * @param {boolean[]|undefined} perDayWorkerOverride
 * @returns {Array<{ startCol: number, endCol: number }>}
 */
export function getOverrideRuns(perDayWorkerOverride) {
  const runs = [];
  if (!Array.isArray(perDayWorkerOverride) || perDayWorkerOverride.length === 0) {
    return runs;
  }
  let i = 0;
  while (i < perDayWorkerOverride.length) {
    if (!perDayWorkerOverride[i]) {
      i += 1;
      continue;
    }
    const startCol = i;
    while (i < perDayWorkerOverride.length && perDayWorkerOverride[i]) {
      i += 1;
    }
    runs.push({ startCol, endCol: i - 1 });
  }
  return runs;
}
